import { ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import AuthLayout from "../layouts/AuthLayout";

export default function SignupPageN() {
  const navigate = useNavigate();

  const goToCreatorSignup = () => {
    navigate("/creative-profile/signup"); // adjust route if needed
  };

  const goToAdminSignup = () => {
    navigate("/signup-admin"); // adjust route if needed
  };

  return (
    <AuthLayout
      title="Create an account"
      subtitle="Choose how you want to sign up."
    >
     <div className="grid grid-cols-1 gap-10 mt-4">

  {/* Creator Card */}
  <div
    onClick={goToCreatorSignup}
    className="cursor-pointer bg-[#F9F4EB] border border-[#F5EBDA] rounded-2xl p-6
    h-[160px] flex items-center
    transition-all duration-300 ease-in-out
    hover:bg-white hover:border-[#F4DAB1] hover:scale-[1.03] hover:shadow-xl"
  >
    <div className="flex items-center justify-between w-full h-full">
      <div className="flex flex-col justify-between h-full w-2/3">
        <p className="text-lg font-semibold">Sign Up as a Creator</p>
        <div className="w-10 h-10 rounded-full border bg-white flex items-center justify-center">
          <ArrowUpRight size={18} />
        </div>
      </div>

      <div className="w-1/3 flex justify-end">
        <img
          src="/images/signup-creator.png"
          alt="Creator"
          className="h-[120px] object-contain transition-transform duration-300 hover:scale-110"
        />
      </div>
    </div>
  </div>

  {/* Admin Card */}
  <div
    onClick={goToAdminSignup}
    className="cursor-pointer bg-[#F9F4EB] border border-[#F5EBDA] rounded-2xl p-6
    h-[160px] flex items-center
    transition-all duration-300 ease-in-out
    hover:bg-white hover:border-[#F4DAB1] hover:scale-[1.03] hover:shadow-xl"
  >
    <div className="flex items-center justify-between w-full h-full">
      <div className="flex flex-col justify-between h-full w-2/3">
        <p className="text-lg font-semibold">Sign Up as an Admin</p>
        <div className="w-10 h-10 rounded-full border bg-white flex items-center justify-center">
          <ArrowUpRight size={18} />
        </div>
      </div>

      <div className="w-1/3 flex justify-end">
        <img
          src="/images/signup-admin.png"
          alt="Admin"
          className="h-[120px] object-contain transition-transform duration-300 hover:scale-110"
        />
      </div>
    </div>
  </div>

</div>

    </AuthLayout>
  );
}
